export enum LicenseRoutes {
  LIST = '/licencas',
  DETAILS = '/licencas/[groupId]',
  EDIT = '/licencas/[groupId]/editar',
}
